/**
 * Generated by Kubb (https://kubb.dev/).
 * Do not edit manually.
 */

import * as z from "zod";
import type { ToZod } from "../.kubb/ToZod.ts";
import type { EUserRole } from "../types/EUserRole.ts";

/**
 * @description 1 = Master | 2 = Administrator | 3 = Polo | 4 = Basic | 5 = Relationship | 6 = Planning | 7 = Secretary | 8 = Communication | 9 = Financial | 10 = Visitor | 11 = API | 12 = StudentCare | 13 = Valoriza | 14 = Leads | 15 = Faculty | 16 = Orientation | 17 = Exams | 18 = BusinessCore | 19 = Contracts | 20 = HumanResources | 21 = Audiovisual | 22 = ScholarshipTeam | 23 = Translation | 24 = Transmission | 25 = RelationshipTR | 26 = International |
 */
export const eUserRoleSchema = z
  .union([
    z.literal(1),
    z.literal(2),
    z.literal(3),
    z.literal(4),
    z.literal(5),
    z.literal(6),
    z.literal(7),
    z.literal(8),
    z.literal(9),
    z.literal(10),
    z.literal(11),
    z.literal(12),
    z.literal(13),
    z.literal(14),
    z.literal(15),
    z.literal(16),
    z.literal(17),
    z.literal(18),
    z.literal(19),
    z.literal(20),
    z.literal(21),
    z.literal(22),
    z.literal(23),
    z.literal(24),
    z.literal(25),
    z.literal(26),
  ])
  .describe(
    "1 = Master | 2 = Administrator | 3 = Polo | 4 = Basic | 5 = Relationship | 6 = Planning | 7 = Secretary | 8 = Communication | 9 = Financial | 10 = Visitor | 11 = API | 12 = StudentCare | 13 = Valoriza | 14 = Leads | 15 = Faculty | 16 = Orientation | 17 = Exams | 18 = BusinessCore | 19 = Contracts | 20 = HumanResources | 21 = Audiovisual | 22 = ScholarshipTeam | 23 = Translation | 24 = Transmission | 25 = RelationshipTR | 26 = International | ",
  ) as unknown as ToZod<EUserRole>;
